import zod from 'zod';

// The validated result is cast to the full IEnergyPlan, which has required fields
// this schema doesn't model (code, contractPeriod, addOns, energyCost.monthlyCost…).
// .loose() preserves them so the cast isn't a runtime lie when the read side builds
// the plan from the parsed data.
export const noSurprisesProductSchema = zod
  .object({
    title: zod.string(),
    tariff: zod
      .object({
        serviceProviderName: zod.string(),
        description: zod.string().nullish(),
        rates: zod.array(zod.unknown()).nullish(),
      })
      .loose(),
    energyCost: zod
      .object({
        predictedMonthlyCost: zod.number(),
        predictedYearlyUsage: zod.number(),
        previousUsage: zod.number().nullish(),
        refPercentSaving: zod.string(),
        predictedYearlyUsageUom: zod.string().nullish(),
        referenceCost: zod.number().nullish(),
        refType: zod.string().nullish(),
        refTariffType: zod.string().nullish(),
      })
      .loose(),
  })
  .loose();

export type NoSurprisesProductPayload = zod.infer<typeof noSurprisesProductSchema>;
